import { useEffect, useState } from 'react';
import { api, type Series } from '../lib/api';

// Series (142): the run this episode belongs to, and its part number. The
// door lists the series on the creator's page and plays it in this order.
export function SeriesRow({ cardId, brandId, seriesId, seriesOrder, onChanged }: {
  cardId: string; brandId: string | null; seriesId: string | null; seriesOrder: number | null; onChanged: () => void | Promise<void>;
}) {
  const [list, setList] = useState<Series[]>([]);
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const load = () => api.series(brandId).then(setList).catch(() => setList([]));
  useEffect(() => { void load(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandId]);
  const set = (sid: string | null, order: number | null) => api.setCardSeries(cardId, sid, order).then(() => onChanged()).catch((e: Error) => setError(e.message));
  return (
    <div className="row wrap" style={{ gap: 8, alignItems: 'center', margin: '0 0 10px' }} data-tool="series-row">
      <span className="sub-dim">Series:</span>
      <select value={seriesId ?? ''} onChange={(e) => { const v = e.target.value; if (v === '__new') { setAdding(true); return; } void set(v || null, v ? seriesOrder : null); }} aria-label="Series">
        <option value="">none</option>
        {list.map((s) => <option key={s.id} value={s.id}>{s.name} ({s.episodes})</option>)}
        {brandId && <option value="__new">+ new series…</option>}
      </select>
      {seriesId && <label className="sub-dim">part <input type="number" min={1} max={9999} value={seriesOrder ?? ''} placeholder="n" style={{ width: 56 }} aria-label="Part number"
                                                     onChange={(e) => { const n = Number(e.target.value); void set(seriesId, Number.isFinite(n) && n >= 1 ? n : null); }} /></label>}
      {adding && brandId && (
        <form className="row" style={{ gap: 6 }} onSubmit={(e) => { e.preventDefault(); if (!name.trim()) return;
          api.createSeries({ brandId, name: name.trim() }).then((s) => { setAdding(false); setName(''); return load().then(() => set(s.id, 1)); }).catch((er: Error) => setError(er.message)); }}>
          <input value={name} onChange={(e) => setName(e.target.value)} maxLength={120} placeholder="Series name" required autoFocus />
          <button type="submit" className="btn tiny pri">Make</button><button type="button" className="btn tiny" onClick={() => setAdding(false)}>Cancel</button>
        </form>
      )}
      {error && <span className="err inline">{error}</span>}
    </div>
  );
}
